export const testIdByErrorType: Record<TWizerErrorType, string> = {
    ACCOUNT_ALREADY_EXISTS: 'toast-wizer-account-already-exists',
    REGISTRATION_NOT_COMPLETE: 'toast-wizer-registration-not-complete',
    INVALID_COMPANY_ID: 'toast-wizer-invalid-company-id',
    GENERAL_ERROR: 'toast-wizer-error',
}
